import { useState, useEffect, useRef } from 'react';


export const calculateTimeLeft = (targetDate: Date) => (): number => Math.max(new Date(targetDate).getTime() - Date.now(), 0);
export const remainingTime = (targetDate: Date): number => Math.max(new Date(targetDate).getTime() - Date.now(), 0);

export const useCountdown = (targetDate: Date) => {
  const [ timeLeft, setTimeLeft ] = useState(calculateTimeLeft(targetDate));
  const intervalIdRef = useRef(null);

  useEffect(() => {
    clearInterval(intervalIdRef.current);

    const updateTimer = () => {
      const remaining = remainingTime(targetDate);
      setTimeLeft(remaining);
      if (remaining === 0) clearInterval(intervalIdRef.current);
    };

    updateTimer(); // Ensure the state updates immediately
    intervalIdRef.current = setInterval(updateTimer, 1000);

    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, [ targetDate ]);

  return timeLeft;
};

export const formatCountdown = (ms: number) => {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};
